module.exports = __webpack_public_path__ + "img/006-tanzania.eb25a2de.svg";